import { render, staticRenderFns } from "./AlertRecordModal.vue?vue&type=template&id=e8b3e242&"
import script from "./AlertRecordModal.vue?vue&type=script&lang=js&"
export * from "./AlertRecordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports